module.exports = __webpack_public_path__ + "static/img/RE5.098cd5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE5.jpg
// module id = HVKI
// module chunks = 0